var _circle, _circle2, _circle3, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgCompleteTicketSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 151,
    viewBox: "0 0 153 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 76.5,
    cy: 75.5,
    r: 70,
    stroke: "#C9FAC5",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 76.5,
    cy: 75.5,
    r: 75,
    stroke: "#C9FAC5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 75.5,
    r: 63.5,
    stroke: "#C9FAC5",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 75C16 41.8629 42.8629 15 76 15C109.137 15 136 41.8629 136 75C136 108.137 109.137 135 76 135C42.8629 135 16 108.137 16 75Z",
    fill: "#20B970"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 120.25C60.3281 120.25 45.5625 111.812 37.4766 97.75C29.3906 83.8633 29.3906 66.8125 37.4766 52.75C45.5625 38.8633 60.3281 30.25 76.5 30.25C92.4961 30.25 107.262 38.8633 115.348 52.75C123.434 66.8125 123.434 83.8633 115.348 97.75C107.262 111.812 92.4961 120.25 76.5 120.25ZM73.8633 89.4883L99.1758 64.1758L93.1992 58.1992L70.875 80.5234L59.8008 69.4492L53.8242 75.4258L67.8867 89.4883L70.875 92.4766L73.8633 89.4883Z",
    fill: "url(#paint0_linear_16418_22985)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16418_22985",
    x1: 76.5,
    y1: 64,
    x2: 76.5,
    y2: 86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFFE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCompleteTicketSuccess);
export default __webpack_public_path__ + "static/media/img_complete_ticket_success.3754023983eb705cdb3d0b2715b1b9be.svg";
export { ForwardRef as ReactComponent };